export default __webpack_public_path__ + "static/media/lock-active.0b8450af.svg";